export const CREATE_GENERAL_INFO = {
  CREATE_GENERAL_INFO_REQUEST: "CREATE_GENERAL_INFO_REQUEST",
  CREATE_GENERAL_INFO_SUCCESS: "CREATE_GENERAL_INFO_SUCCESS",
  CREATE_GENERAL_INFO_FAILED: "CREATE_GENERAL_INFO_FAILED",
};

export const GET_GENERAL_INFO = {
  GET_GENERAL_INFO_REQUEST: "GET_GENERAL_INFO_REQUEST",
  GET_GENERAL_INFO_SUCCESS: "GET_GENERAL_INFO_SUCCESS",
  GET_GENERAL_INFO_FAILED: "GET_GENERAL_INFO_FAILED",
};

export const UPDATE_GENERAL_INFO = {
  UPDATE_GENERAL_INFO_REQUEST: "UPDATE_GENERAL_INFO_REQUEST",
  UPDATE_GENERAL_INFO_SUCCESS: "UPDATE_GENERAL_INFO_SUCCESS",
  UPDATE_GENERAL_INFO_FAILED: "UPDATE_GENERAL_INFO_FAILED",
};

export const CREATE_SERVICES = {
  CREATE_SERVICES_REQUEST: "CREATE_SERVICES_REQUEST",
  CREATE_SERVICES_SUCCESS: "CREATE_SERVICES_SUCCESS",
  CREATE_SERVICES_FAILED: "CREATE_SERVICES_FAILED",
};

export const GET_SERVICES = {
  GET_SERVICES_REQUEST: "GET_SERVICES_REQUEST",
  GET_SERVICES_SUCCESS: "GET_SERVICES_SUCCESS",
  GET_SERVICES_FAILED: "GET_SERVICES_FAILED",
};

export const CREATE_POSTINGS = {
  CREATE_POSTINGS_REQUEST: "CREATE_POSTINGS_REQUEST",
  CREATE_POSTINGS_SUCCESS: "CREATE_POSTINGS_SUCCESS",
  CREATE_POSTINGS_FAILED: "CREATE_POSTINGS_FAILED",
};

export const GET_POSTINGS = {
  GET_POSTINGS_REQUEST: "GET_POSTINGS_REQUEST",
  GET_POSTINGS_SUCCESS: "GET_POSTINGS_SUCCESS",
  GET_POSTINGS_FAILED: "GET_POSTINGS_FAILED",
};

export const UPDATE_EDUCATION_INFO = {
  UPDATE_EDUCATION_INFO_REQUEST: "UPDATE_EDUCATION_INFO_REQUEST",
  UPDATE_EDUCATION_INFO_SUCCESS: "UPDATE_EDUCATION_INFO_SUCCESS",
  UPDATE_EDUCATION_INFO_FAILED: "UPDATE_EDUCATION_INFO_FAILED",
};

export const DELETE_EDUCATION_INFO = {
  DELETE_EDUCATION_INFO_REQUEST: "DELETE_EDUCATION_INFO_REQUEST",
  DELETE_EDUCATION_INFO_SUCCESS: "DELETE_EDUCATION_INFO_SUCCESS",
  DELETE_EDUCATION_INFO_FAILED: "DELETE_EDUCATION_INFO_FAILED",
};

export const CREATE_QUALIFICATIONS = {
  CREATE_QUALIFICATIONS_REQUEST: "CREATE_QUALIFICATIONS_REQUEST",
  CREATE_QUALIFICATIONS_SUCCESS: "CREATE_QUALIFICATIONS_SUCCESS",
  CREATE_QUALIFICATIONS_FAILED: "CREATE_QUALIFICATIONS_FAILED",
};

export const GET_QUALIFICATION = {
  GET_QUALIFICATION_REQUEST: "GET_QUALIFICATION_REQUEST",
  GET_QUALIFICATION_SUCCESS: "GET_QUALIFICATION_SUCCESS",
  GET_QUALIFICATION_FAILED: "GET_QUALIFICATION_FAILED",
};

export const UPDATE_ABROAD_POSTING_INFO = {
  UPDATE_ABROAD_POSTING_INFO_REQUEST: "UPDATE_ABROAD_POSTING_INFO_REQUEST",
  UPDATE_ABROAD_POSTING_INFO_SUCCESS: "UPDATE_ABROAD_POSTING_INFO_SUCCESS",
  UPDATE_ABROAD_POSTING_INFO_FAILED: "UPDATE_ABROAD_POSTING_INFO_FAILED",
};

export const DELETE_ABROAD_POSTING_INFO = {
  DELETE_ABROAD_POSTING_INFO_REQUEST: "DELETE_ABROAD_POSTING_INFO_REQUEST",
  DELETE_ABROAD_POSTING_INFO_SUCCESS: "DELETE_ABROAD_POSTING_INFO_SUCCESS",
  DELETE_ABROAD_POSTING_INFO_FAILED: "DELETE_ABROAD_POSTING_INFO_FAILED",
};

export const UPDATE_ATTACHMENT_POSTING_INFO = {
  UPDATE_ATTACHMENT_POSTING_INFO_REQUEST:
    "UPDATE_ATTACHMENT_POSTING_INFO_REQUEST",
  UPDATE_ATTACHMENT_POSTING_INFO_SUCCESS:
    "UPDATE_ATTACHMENT_POSTING_INFO_SUCCESS",
  UPDATE_ATTACHMENT_POSTING_INFO_FAILED:
    "UPDATE_ATTACHMENT_POSTING_INFO_FAILED",
};

export const DELETE_ATTACHMENT_POSTING_INFO = {
  DELETE_ATTACHMENT_POSTING_INFO_REQUEST:
    "DELETE_ATTACHMENT_POSTING_INFO_REQUEST",
  DELETE_ATTACHMENT_POSTING_INFO_SUCCESS:
    "DELETE_ATTACHMENT_POSTING_INFO_SUCCESS",
  DELETE_ATTACHMENT_POSTING_INFO_FAILED:
    "DELETE_ATTACHMENT_POSTING_INFO_FAILED",
};

export const UPDATE_CONTRACTUAL_POSTING_INFO = {
  UPDATE_CONTRACTUAL_POSTING_INFO_REQUEST:
    "UPDATE_CONTRACTUAL_POSTING_INFO_REQUEST",
  UPDATE_CONTRACTUAL_POSTING_INFO_SUCCESS:
    "UPDATE_CONTRACTUAL_POSTING_INFO_SUCCESS",
  UPDATE_CONTRACTUAL_POSTING_INFO_FAILED:
    "UPDATE_CONTRACTUAL_POSTING_INFO_FAILED",
};

export const DELETE_CONTRACTUAL_POSTING_INFO = {
  DELETE_CONTRACTUAL_POSTING_INFO_REQUEST:
    "DELETE_CONTRACTUAL_POSTING_INFO_REQUEST",
  DELETE_CONTRACTUAL_POSTING_INFO_SUCCESS:
    "DELETE_CONTRACTUAL_POSTING_INFO_SUCCESS",
  DELETE_CONTRACTUAL_POSTING_INFO_FAILED:
    "DELETE_CONTRACTUAL_POSTING_INFO_FAILED",
};

export const UPDATE_DEPUTATION_POSTING_INFO = {
  UPDATE_DEPUTATION_POSTING_INFO_REQUEST:
    "UPDATE_DEPUTATION_POSTING_INFO_REQUEST",
  UPDATE_DEPUTATION_POSTING_INFO_SUCCESS:
    "UPDATE_DEPUTATION_POSTING_INFO_SUCCESS",
  UPDATE_DEPUTATION_POSTING_INFO_FAILED:
    "UPDATE_DEPUTATION_POSTING_INFO_FAILED",
};

export const DELETE_DEPUTATION_POSTING_INFO = {
  DELETE_DEPUTATION_POSTING_INFO_REQUEST:
    "DELETE_DEPUTATION_POSTING_INFO_REQUEST",
  DELETE_DEPUTATION_POSTING_INFO_SUCCESS:
    "DELETE_DEPUTATION_POSTING_INFO_SUCCESS",
  DELETE_DEPUTATION_POSTING_INFO_FAILED:
    "DELETE_DEPUTATION_POSTING_INFO_FAILED",
};

export const UPDATE_POSTING_RECORD_POSTING_INFO = {
  UPDATE_POSTING_RECORD_POSTING_INFO_REQUEST:
    "UPDATE_POSTING_RECORD_POSTING_INFO_REQUEST",
  UPDATE_POSTING_RECORD_POSTING_INFO_SUCCESS:
    "UPDATE_POSTING_RECORD_POSTING_INFO_SUCCESS",
  UPDATE_POSTING_RECORD_POSTING_INFO_FAILED:
    "UPDATE_POSTING_RECORD_POSTING_INFO_FAILED",
};

export const DELETE_POSTING_RECORD_POSTING_INFO = {
  DELETE_POSTING_RECORD_POSTING_INFO_REQUEST:
    "DELETE_POSTING_RECORD_POSTING_INFO_REQUEST",
  DELETE_POSTING_RECORD_POSTING_INFO_SUCCESS:
    "DELETE_POSTING_RECORD_POSTING_INFO_SUCCESS",
  DELETE_POSTING_RECORD_POSTING_INFO_FAILED:
    "DELETE_POSTING_RECORD_POSTING_INFO_FAILED",
};

export const UPDATE_FOREIGN_TRAVEL_POSTING_INFO = {
  UPDATE_FOREIGN_TRAVEL_POSTING_INFO_REQUEST:
    "UPDATE_FOREIGN_TRAVEL_POSTING_INFO_REQUEST",
  UPDATE_FOREIGN_TRAVEL_POSTING_INFO_SUCCESS:
    "UPDATE_FOREIGN_TRAVEL_POSTING_INFO_SUCCESS",
  UPDATE_FOREIGN_TRAVEL_POSTING_INFO_FAILED:
    "UPDATE_FOREIGN_TRAVEL_POSTING_INFO_FAILED",
};

export const DELETE_FOREIGN_TRAVEL_POSTING_INFO = {
  DELETE_FOREIGN_TRAVEL_POSTING_INFO_REQUEST:
    "DELETE_FOREIGN_TRAVEL_POSTING_INFO_REQUEST",
  DELETE_FOREIGN_TRAVEL_POSTING_INFO_SUCCESS:
    "DELETE_FOREIGN_TRAVEL_POSTING_INFO_SUCCESS",
  DELETE_FOREIGN_TRAVEL_POSTING_INFO_FAILED:
    "DELETE_FOREIGN_TRAVEL_POSTING_INFO_FAILED",
};

export const UPDATE_LOCAL_TRAINING_INFO = {
  UPDATE_LOCAL_TRAINING_INFO_REQUEST: "UPDATE_LOCAL_TRAINING_INFO_REQUEST",
  UPDATE_LOCAL_TRAINING_INFO_SUCCESS: "UPDATE_LOCAL_TRAINING_INFO_SUCCESS",
  UPDATE_LOCAL_TRAINING_INFO_FAILED: "UPDATE_LOCAL_TRAINING_INFO_FAILED",
};

export const DELETE_LOCAL_TRAINING_INFO = {
  DELETE_LOCAL_TRAINING_INFO_REQUEST: "DELETE_LOCAL_TRAINING_INFO_REQUEST",
  DELETE_LOCAL_TRAINING_INFO_SUCCESS: "DELETE_LOCAL_TRAINING_INFO_SUCCESS",
  DELETE_LOCAL_TRAINING_INFO_FAILED: "DELETE_LOCAL_TRAINING_INFO_FAILED",
};

export const UPDATE_FOREIGN_TRAINING_INFO = {
  UPDATE_FOREIGN_TRAINING_INFO_REQUEST: "UPDATE_FOREIGN_TRAINING_INFO_REQUEST",
  UPDATE_FOREIGN_TRAINING_INFO_SUCCESS: "UPDATE_FOREIGN_TRAINING_INFO_SUCCESS",
  UPDATE_FOREIGN_TRAINING_INFO_FAILED: "UPDATE_FOREIGN_TRAINING_INFO_FAILED",
};

export const DELETE_FOREIGN_TRAINING_INFO = {
  DELETE_FOREIGN_TRAINING_INFO_REQUEST: "DELETE_FOREIGN_TRAINING_INFO_REQUEST",
  DELETE_FOREIGN_TRAINING_INFO_SUCCESS: "DELETE_FOREIGN_TRAINING_INFO_SUCCESS",
  DELETE_FOREIGN_TRAINING_INFO_FAILED: "DELETE_FOREIGN_TRAINING_INFO_FAILED",
};

export const UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO = {
  UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_REQUEST:
    "UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_REQUEST",
  UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_SUCCESS:
    "UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_SUCCESS",
  UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_FAILED:
    "UPDATE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_FAILED",
};

export const DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO = {
  DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_REQUEST:
    "DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_REQUEST",
  DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_SUCCESS:
    "DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_SUCCESS",
  DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_FAILED:
    "DELETE_ADDITIONAL_PROFESSIONAL_QUALIFICATION_INFO_FAILED",
};

export const UPDATE_PUBLICATION_INFO = {
  UPDATE_PUBLICATION_INFO_REQUEST: "UPDATE_PUBLICATION_INFO_REQUEST",
  UPDATE_PUBLICATION_INFO_SUCCESS: "UPDATE_PUBLICATION_INFO_SUCCESS",
  UPDATE_PUBLICATION_INFO_FAILED: "UPDATE_PUBLICATION_INFO_FAILED",
};

export const DELETE_PUBLICATION_INFO = {
  DELETE_PUBLICATION_INFO_REQUEST: "DELETE_PUBLICATION_INFO_REQUEST",
  DELETE_PUBLICATION_INFO_SUCCESS: "DELETE_PUBLICATION_INFO_SUCCESS",
  DELETE_PUBLICATION_INFO_FAILED: "DELETE_PUBLICATION_INFO_FAILED",
};

export const UPDATE_HONOUR_INFO = {
  UPDATE_HONOUR_INFO_REQUEST: "UPDATE_HONOUR_INFO_REQUEST",
  UPDATE_HONOUR_INFO_SUCCESS: "UPDATE_HONOUR_INFO_SUCCESS",
  UPDATE_HONOUR_INFO_FAILED: "UPDATE_HONOUR_INFO_FAILED",
};

export const DELETE_HONOUR_INFO = {
  DELETE_HONOUR_INFO_REQUEST: "DELETE_HONOUR_INFO_REQUEST",
  DELETE_HONOUR_INFO_SUCCESS: "DELETE_HONOUR_INFO_SUCCESS",
  DELETE_HONOUR_INFO_FAILED: "DELETE_HONOUR_INFO_FAILED",
};

export const UPDATE_REWARD_INFO = {
  UPDATE_REWARD_INFO_REQUEST: "UPDATE_REWARD_INFO_REQUEST",
  UPDATE_REWARD_INFO_SUCCESS: "UPDATE_REWARD_INFO_SUCCESS",
  UPDATE_REWARD_INFO_FAILED: "UPDATE_REWARD_INFO_FAILED",
};

export const DELETE_REWARD_INFO = {
  DELETE_REWARD_INFO_REQUEST: "DELETE_REWARD_INFO_REQUEST",
  DELETE_REWARD_INFO_SUCCESS: "DELETE_REWARD_INFO_SUCCESS",
  DELETE_REWARD_INFO_FAILED: "DELETE_REWARD_INFO_FAILED",
};

export const CREATE_EMPLOYEE_FAMILY = {
  CREATE_FAMILY_REQUEST: "CREATE_FAMILY_REQUEST",
  CREATE_FAMILY_SUCCESS: "CREATE_FAMILY_SUCCESS",
  CREATE_FAMILY_FAILED: "CREATE_FAMILY_FAILED",
};

export const GET_EMPLOYEE_FAMILY = {
  GET_FAMILY_REQUEST: "GET_FAMILY_REQUEST",
  GET_FAMILY_SUCCESS: "GET_FAMILY_SUCCESS",
  GET_FAMILY_FAILED: "GET_FAMILY_FAILED",
};

export const UPDATE_PARENT_INFO = {
  UPDATE_PARENT_INFO_REQUEST: "UPDATE_PARENT_INFO_REQUEST",
  UPDATE_PARENT_INFO_SUCCESS: "UPDATE_PARENT_INFO_SUCCESS",
  UPDATE_PARENT_INFO_FAILED: "UPDATE_PARENT_INFO_FAILED",
};

export const UPDATE_SPOUSE_INFO = {
  UPDATE_SPOUSE_INFO_REQUEST: "UPDATE_SPOUSE_INFO_REQUEST",
  UPDATE_SPOUSE_INFO_SUCCESS: "UPDATE_SPOUSE_INFO_SUCCESS",
  UPDATE_SPOUSE_INFO_FAILED: "UPDATE_SPOUSE_INFO_FAILED",
};

export const DELETE_SPOUSE_INFO = {
  DELETE_SPOUSE_INFO_REQUEST: "DELETE_SPOUSE_INFO_REQUEST",
  DELETE_SPOUSE_INFO_SUCCESS: "DELETE_SPOUSE_INFO_SUCCESS",
  DELETE_SPOUSE_INFO_FAILED: "DELETE_SPOUSE_INFO_FAILED",
};

export const UPDATE_CHILDREN_INFO = {
  UPDATE_CHILDREN_INFO_REQUEST: "UPDATE_CHILDREN_INFO_REQUEST",
  UPDATE_CHILDREN_INFO_SUCCESS: "UPDATE_CHILDREN_INFO_SUCCESS",
  UPDATE_CHILDREN_INFO_FAILED: "UPDATE_CHILDREN_INFO_FAILED",
};

export const DELETE_CHILD_INFO = {
  DELETE_CHILD_INFO_REQUEST: "DELETE_CHILD_INFO_REQUEST",
  DELETE_CHILD_INFO_SUCCESS: "DELETE_CHILD_INFO_SUCCESS",
  DELETE_CHILD_INFO_FAILED: "DELETE_CHILD_INFO_FAILED",
};

export const UPDATE_EMERGENCY_CONTACT_INFO = {
  UPDATE_EMERGENCY_CONTACT_INFO_REQUEST:
    "UPDATE_EMERGENCY_CONTACT_INFO_REQUEST",
  UPDATE_EMERGENCY_CONTACT_INFO_SUCCESS:
    "UPDATE_EMERGENCY_CONTACT_INFO_SUCCESS",
  UPDATE_EMERGENCY_CONTACT_INFO_FAILED: "UPDATE_EMERGENCY_CONTACT_INFO_FAILED",
};

export const UPDATE_PERMANENT_ADDRESS_INFO = {
  UPDATE_PERMANENT_ADDRESS_INFO_REQUEST:
    "UPDATE_PERMANENT_ADDRESS_INFO_REQUEST",
  UPDATE_PERMANENT_ADDRESS_INFO_SUCCESS:
    "UPDATE_PERMANENT_ADDRESS_INFO_SUCCESS",
  UPDATE_PERMANENT_ADDRESS_INFO_FAILED: "UPDATE_PERMANENT_ADDRESS_INFO_FAILED",
};

export const UPDATE_PRESENT_ADDRESS_INFO = {
  UPDATE_PRESENT_ADDRESS_INFO_REQUEST: "UPDATE_PRESENT_ADDRESS_INFO_REQUEST",
  UPDATE_PRESENT_ADDRESS_INFO_SUCCESS: "UPDATE_PRESENT_ADDRESS_INFO_SUCCESS",
  UPDATE_PRESENT_ADDRESS_INFO_FAILED: "UPDATE_PRESENT_ADDRESS_INFO_FAILED",
};

export const CREATE_DISCIPLINE = {
  CREATE_DISCIPLINE_REQUEST: "CREATE_DISCIPLINE_REQUEST",
  CREATE_DISCIPLINE_SUCCESS: "CREATE_DISCIPLINE_SUCCESS",
  CREATE_DISCIPLINE_FAILED: "CREATE_DISCIPLINE_FAILED",
};

export const UPDATE_DISCIPLINE = {
  UPDATE_DISCIPLINE_REQUEST: "UPDATE_DISCIPLINE_REQUEST",
  UPDATE_DISCIPLINE_SUCCESS: "UPDATE_DISCIPLINE_SUCCESS",
  UPDATE_DISCIPLINE_FAILED: "UPDATE_DISCIPLINE_FAILED",
};

export const GET_DISCIPLINE_HISTORY = {
  GET_DISCIPLINE_HISTORY_REQUEST: "GET_DISCIPLINE_HISTORY_REQUEST",
  GET_DISCIPLINE_HISTORY_SUCCESS: "GET_DISCIPLINE_HISTORY_SUCCESS",
  GET_DISCIPLINE_HISTORY_FAILED: "GET_DISCIPLINE_HISTORY_FAILED",
};

export const DELETE_DISCIPLINE_HISTORY = {
  DELETE_DISCIPLINE_TABLE_REQUEST: "DELETE_DISCIPLINE_TABLE_REQUEST",
  DELETE_DISCIPLINE_TABLE_SUCCESS: "DELETE_DISCIPLINE_TABLE_SUCCESS",
  DELETE_DISCIPLINE_TABLE_FAILED: "GET_DISCIPLINE_TABLE_FAILED",
};

export const CREATE_ACR = {
  CREATE_ACR_REQUEST: "CREATE_ACR_REQUEST",
  CREATE_ACR_SUCCESS: "CREATE_ACR_SUCCESS",
  CREATE_ACR_FAILED: "CREATE_ACR_FAILED",
};

export const GET_ACRS_HISTORY = {
  GET_ACR_HISTORY_REQUEST: "GET_ACR_HISTORY_REQUEST",
  GET_ACR_HISTORY_SUCCESS: "GET_ACR_HISTORY_SUCCESS",
  GET_ACR_HISTORY_FAILED: "GET_ACR_HISTORY_FAILED",
};

export const DELETE_ACR_HISTORY = {
  DELETE_ACR_HISTORY_REQUEST: "DELETE_ACR_HISTORY_REQUEST",
  DELETE_ACR_HISTORY_SUCCESS: "DELETE_ACR_HISTORY_SUCCESS",
  DELETE_ACR_HISTORY_FAILED: "DELETE_ACR_HISTORY_FAILED",
};

export const CREATE_APR = {
  CREATE_APR_REQUEST: "CREATE_APR_REQUEST",
  CREATE_APR_SUCCESS: "CREATE_APR_SUCCESS",
  CREATE_APR_FAILED: "CREATE_APR_FAILED",
};

export const DELETE_APR = {
  DELETE_APR_REQUEST: "DELETE_APR_REQUEST",
  DELETE_APR_SUCCESS: "DELETE_APR_SUCCESS",
  DELETE_APR_FAILED: "DELETE_APR_FAILED",
};

export const GET_APR = {
  GET_APR_REQUEST: "GET_APR_REQUEST",
  GET_APR_SUCCESS: "GET_APR_SUCCESS",
  GET_APR_FAILED: "GET_APR_FAILED",
};

export const UPDATE_APR = {
  UPDATE_APR_REQUEST: "UPDATE_APR_REQUEST",
  UPDATE_APR_SUCCESS: "UPDATE_APR_SUCCESS",
  UPDATE_APR_FAILED: "UPDATE_APR_FAILED",
};

export const UPDATE_SERVICE_HISTORY_INFO = {
  UPDATE_SERVICE_HISTORY_INFO_REQUEST: "UPDATE_SERVICE_HISTORY_INFO_REQUEST",
  UPDATE_SERVICE_HISTORY_INFO_SUCCESS: "UPDATE_SERVICE_HISTORY_INFO_SUCCESS",
  UPDATE_SERVICE_HISTORY_INFO_FAILED: "UPDATE_SERVICE_HISTORY_INFO_FAILED",
};

export const UPDATE_PROMOTION_PARTICULARS_INFO = {
  UPDATE_PROMOTION_PARTICULARS_INFO_REQUEST:
    "UPDATE_PROMOTION_PARTICULARS_INFO_REQUEST",
  UPDATE_PROMOTION_PARTICULARS_INFO_SUCCESS:
    "UPDATE_PROMOTION_PARTICULARS_INFO_SUCCESS",
  UPDATE_PROMOTION_PARTICULARS_INFO_FAILED:
    "UPDATE_PROMOTION_PARTICULARS_INFO_FAILED",
};

export const UPDATE_OTHER_SERVICES_INFO = {
  UPDATE_OTHER_SERVICES_INFO_REQUEST: "UPDATE_OTHER_SERVICES_INFO_REQUEST",
  UPDATE_OTHER_SERVICES_INFO_SUCCESS: "UPDATE_OTHER_SERVICES_INFO_SUCCESS",
  UPDATE_OTHER_SERVICES_INFO_FAILED: "UPDATE_OTHER_SERVICES_INFO_FAILED",
};

export const DELETE_SERVICE_HISTORY_INFO = {
  DELETE_SERVICE_HISTORY_INFO_REQUEST: "DELETE_SERVICE_HISTORY_INFO_REQUEST",
  DELETE_SERVICE_HISTORY_INFO_SUCCESS: "DELETE_SERVICE_HISTORY_INFO_SUCCESS",
  DELETE_SERVICE_HISTORY_INFO_FAILED: "DELETE_SERVICE_HISTORY_INFO_FAILED",
};

export const DELETE_PROMOTION_PARTICULARS_INFO = {
  DELETE_PROMOTION_PARTICULARS_INFO_REQUEST:
    "DELETE_PROMOTION_PARTICULARS_INFO_REQUEST",
  DELETE_PROMOTION_PARTICULARS_INFO_SUCCESS:
    "DELETE_PROMOTION_PARTICULARS_INFO_SUCCESS",
  DELETE_PROMOTION_PARTICULARS_INFO_FAILED:
    "DELETE_PROMOTION_PARTICULARS_INFO_FAILED",
};

export const DELETE_OTHER_SERVICES_INFO = {
  DELETE_OTHER_SERVICES_INFO_REQUEST: "DELETE_OTHER_SERVICES_INFO_REQUEST",
  DELETE_OTHER_SERVICES_INFO_SUCCESS: "DELETE_OTHER_SERVICES_INFO_SUCCESS",
  DELETE_OTHER_SERVICES_INFO_FAILED: "DELETE_OTHER_SERVICES_INFO_FAILED",
};

export const CREATE_ATTACHED_FILE_INFO = {
  CREATE_ATTACHED_FILE_INFO_REQUEST: "CREATE_ATTACHED_FILE_INFO_REQUEST",
  CREATE_ATTACHED_FILE_INFO_SUCCESS: "CREATE_ATTACHED_FILE_INFO_SUCCESS",
  CREATE_ATTACHED_FILE_INFO_FAILED: "CREATE_ATTACHED_FILE_INFO_FAILED",
};

export const GET_ATTACHED_FILES_INFO = {
  GET_ATTACHED_FILES_INFO_REQUEST: "GET_ATTACHED_FILES_INFO_REQUEST",
  GET_ATTACHED_FILES_INFO_SUCCESS: "GET_ATTACHED_FILES_INFO_SUCCESS",
  GET_ATTACHED_FILES_INFO_FAILED: "GET_ATTACHED_FILES_INFO_FAILED",
};

export const DELETE_ATTACHED_FILE_INFO = {
  DELETE_ATTACHED_FILE_INFO_REQUEST: "DELETE_ATTACHED_FILE_INFO_REQUEST",
  DELETE_ATTACHED_FILE_INFO_SUCCESS: "DELETE_ATTACHED_FILE_INFO_SUCCESS",
  DELETE_ATTACHED_FILE_INFO_FAILED: "DELETE_ATTACHED_FILE_INFO_FAILED",
};
